module.exports = __webpack_public_path__ + "img/left.c3ee1630.png";